// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HubV1GetAccountDefaultResponse {
    static getAttributeTypeMap() {
        return HubV1GetAccountDefaultResponse.attributeTypeMap;
    }
}
HubV1GetAccountDefaultResponse.discriminator = undefined;
HubV1GetAccountDefaultResponse.additionalProperties = false;
HubV1GetAccountDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetAccountResponseModel"
    },
];
//# sourceMappingURL=hubV1GetAccountDefaultResponse.js.map